module.exports = __webpack_public_path__ + "static/4-87e7b4e3565278a7d036865693fbeb69.jpg";